import React from "react";
import ButtonOval from "./ButtonOval";

export const Ranking = ({ baseExperience, weaknesses }) => {
  return (
    <div className="details">
      <h2 className="height-poke">WEAKNESSES</h2>
      <h2 className="weight-poke">BASE EXP</h2>
      <ButtonOval elementName={weaknesses ? weaknesses : "?"} />
      <ButtonOval elementName={baseExperience ? baseExperience : "?"} />
    </div>
  );
};

export default Ranking;
